// Set auth token in localStorage
export const setAuthToken = (accessToken, refreshToken, user) => {
  localStorage.setItem('access_token', accessToken);
  localStorage.setItem('refresh_token', refreshToken);
  localStorage.setItem('user', JSON.stringify(user));
};

// Remove auth token from localStorage
export const removeAuthToken = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
};

// Get access token from localStorage
export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

// Get refresh token from localStorage
export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

// Get stored user info
export const getStoredUser = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const userString = localStorage.getItem('user');
  
  if (!accessToken || !refreshToken || !userString) {
    return null;
  }
  
  try {
    const user = JSON.parse(userString);
    return { 
      access_token: accessToken, 
      refresh_token: refreshToken, 
      user 
    };
  } catch (error) {
    return null;
  }
};

// Format currency
export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '₹0';
  
  // Using the Indian Rupee symbol (₹) explicitly
  return '₹' + new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(amount);
};

// Check if user has permission
export const hasPermission = (user, requiredRoles = []) => {
  if (!user) return false;
  
  // If no specific roles required, any authenticated user has permission
  if (requiredRoles.length === 0) return true;
  
  // Check if user role is in the required roles
  if (requiredRoles.includes(user.role)) return true;
  
  // Check for special case of association_admin
  if (requiredRoles.includes('association_admin') && user.is_association_admin && user.role === 'subadmin') {
    return true;
  }
  
  return false;
};